export enum NotificationState {
  read = 'read',
  unread = 'unread',
}
